
/**
 * Bundled by jsDelivr using Rollup v2.79.2 and Terser v5.39.0.
 * Original file: /npm/@googlemaps/markerclusterer@2.5.3/dist/index.esm.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
import t from "./fast-deep-equal-v3.1.3.esm.js";
import e from "./supercluster-v8.0.1.esm.js";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function s(t, e) {
	var s = {};
	for (var r in t)
		Object.prototype.hasOwnProperty.call(t, r) &&
			e.indexOf(r) < 0 &&
			(s[r] = t[r]);
	if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
		var o = 0;
		for (r = Object.getOwnPropertySymbols(t); o < r.length; o++)
			e.indexOf(r[o]) < 0 &&
				Object.prototype.propertyIsEnumerable.call(t, r[o]) &&
				(s[r[o]] = t[r[o]]);
	}
	return s;
}
class r {
	static isAdvancedMarkerAvailable(t) {
		return (
			google.maps.marker &&
			!0 === t.getMapCapabilities().isAdvancedMarkersAvailable
		);
	}
	static isAdvancedMarker(t) {
		return (
			google.maps.marker &&
			t instanceof google.maps.marker.AdvancedMarkerElement
		);
	}
	static setMap(t, e) {
		this.isAdvancedMarker(t) ? (t.map = e) : t.setMap(e);
	}
	static getPosition(t) {
		if (this.isAdvancedMarker(t)) {
			if (t.position) {
				if (t.position instanceof google.maps.LatLng) return t.position;
				if (t.position.lat && t.position.lng)
					return new google.maps.LatLng(
						t.position.lat,
						t.position.lng
					);
			}
			return new google.maps.LatLng(null);
		}
		return t.getPosition();
	}
	static getVisible(t) {
		return !!this.isAdvancedMarker(t) || t.getVisible();
	}
}
class o {
	constructor({ markers: t, position: e }) {
		(this.markers = t),
			e &&
				(e instanceof google.maps.LatLng
					? (this._position = e)
					: (this._position = new google.maps.LatLng(e)));
	}
	get bounds() {
		if (0 === this.markers.length && !this._position) return;
		const t = new google.maps.LatLngBounds(this._position, this._position);
		for (const e of this.markers) t.extend(r.getPosition(e));
		return t;
	}
	get position() {
		return this._position || this.bounds.getCenter();
	}
	get count() {
		return this.markers.filter((t) => r.getVisible(t)).length;
	}
	push(t) {
		this.markers.push(t);
	}
	delete() {
		this.marker && (r.setMap(this.marker, null), (this.marker = void 0)),
			(this.markers.length = 0);
	}
}
const a = (t, e, s, o) => {
		const a = i(t.getBounds(), e, o);
		return s.filter((t) => a.contains(r.getPosition(t)));
	},
	i = (t, e, s) => {
		const { northEast: r, southWest: o } = m(t, e),
			a = c({ northEast: r, southWest: o }, s);
		return h(a, e);
	},
	n = (t, e, s) => {
		const r = i(t, e, s),
			o = r.getNorthEast(),
			a = r.getSouthWest();
		return [a.lng(), a.lat(), o.lng(), o.lat()];
	},
	l = (t, e) => {
		const s = ((e.lat - t.lat) * Math.PI) / 180,
			r = ((e.lng - t.lng) * Math.PI) / 180,
			o = Math.sin(s / 2),
			a = Math.sin(r / 2),
			i =
				o * o +
				Math.cos((t.lat * Math.PI) / 180) *
					Math.cos((e.lat * Math.PI) / 180) *
					a *
					a;
		return 6371 * (2 * Math.atan2(Math.sqrt(i), Math.sqrt(1 - i)));
	},
	m = (t, e) => ({
		northEast: e.fromLatLngToDivPixel(t.getNorthEast()),
		southWest: e.fromLatLngToDivPixel(t.getSouthWest()),
	}),
	c = ({ northEast: t, southWest: e }, s) => (
		(t.x += s),
		(t.y -= s),
		(e.x -= s),
		(e.y += s),
		{ northEast: t, southWest: e }
	),
	h = ({ northEast: t, southWest: e }, s) => {
		const r = s.fromDivPixelToLatLng(e),
			o = s.fromDivPixelToLatLng(t);
		return new google.maps.LatLngBounds(r, o);
	};
class u {
	constructor({ maxZoom: t = 16 }) {
		this.maxZoom = t;
	}
	noop({ markers: t }) {
		return g(t);
	}
}
class p extends u {
	constructor(t) {
		var { viewportPadding: e = 60 } = t;
		super(s(t, ["viewportPadding"])),
			(this.viewportPadding = 60),
			(this.viewportPadding = e);
	}
	calculate({ markers: t, map: e, mapCanvasProjection: s }) {
		return e.getZoom() >= this.maxZoom
			? { clusters: this.noop({ markers: t }), changed: !1 }
			: {
					clusters: this.cluster({
						markers: a(e, s, t, this.viewportPadding),
						map: e,
						mapCanvasProjection: s,
					}),
			  };
	}
}
const g = (t) =>
	t.map((t) => new o({ position: r.getPosition(t), markers: [t] }));
class d extends p {
	constructor(t) {
		var { maxDistance: e = 4e4, gridSize: r = 40 } = t;
		super(s(t, ["maxDistance", "gridSize"])),
			(this.clusters = []),
			(this.state = { zoom: -1 }),
			(this.maxDistance = e),
			(this.gridSize = r);
	}
	calculate({ markers: e, map: s, mapCanvasProjection: r }) {
		const o = { zoom: s.getZoom() };
		let i = !1;
		return (
			(this.state.zoom >= this.maxZoom && o.zoom >= this.maxZoom) ||
				(i = !t(this.state, o)),
			(this.state = o),
			s.getZoom() >= this.maxZoom
				? { clusters: this.noop({ markers: e }), changed: i }
				: {
						clusters: this.cluster({
							markers: a(s, r, e, this.viewportPadding),
							map: s,
							mapCanvasProjection: r,
						}),
				  }
		);
	}
	cluster({ markers: t, map: e, mapCanvasProjection: s }) {
		return (
			(this.clusters = []),
			t.forEach((t) => {
				this.addToClosestCluster(t, e, s);
			}),
			this.clusters
		);
	}
	addToClosestCluster(t, e, s) {
		let a = this.maxDistance,
			n = null;
		for (let e = 0; e < this.clusters.length; e++) {
			const s = this.clusters[e],
				o = l(s.bounds.getCenter().toJSON(), r.getPosition(t).toJSON());
			o < a && ((a = o), (n = s));
		}
		if (n && i(n.bounds, s, this.gridSize).contains(r.getPosition(t)))
			n.push(t);
		else {
			const e = new o({ markers: [t] });
			this.clusters.push(e);
		}
	}
}
class k extends u {
	constructor(t) {
		super(s(t, []));
	}
	calculate({ markers: t, map: e, mapCanvasProjection: s }) {
		return {
			clusters: this.cluster({
				markers: t,
				map: e,
				mapCanvasProjection: s,
			}),
			changed: !1,
		};
	}
	cluster(t) {
		return this.noop(t);
	}
}
class f extends u {
	constructor(t) {
		var { maxZoom: r, radius: o = 60 } = t,
			a = s(t, ["maxZoom", "radius"]);
		super({ maxZoom: r }),
			(this.state = { zoom: -1 }),
			(this.superCluster = new e(
				Object.assign({ maxZoom: this.maxZoom, radius: o }, a)
			));
	}
	calculate(e) {
		let s = !1;
		const o = { zoom: e.map.getZoom() };
		if (!t(e.markers, this.markers)) {
			(s = !0), (this.markers = [...e.markers]);
			const t = this.markers.map((t) => {
				const e = r.getPosition(t);
				return {
					type: "Feature",
					geometry: {
						type: "Point",
						coordinates: [e.lng(), e.lat()],
					},
					properties: { marker: t },
				};
			});
			this.superCluster.load(t);
		}
		return (
			s ||
				((this.state.zoom <= this.maxZoom || o.zoom <= this.maxZoom) &&
					(s = !t(this.state, o))),
			(this.state = o),
			s && (this.clusters = this.cluster(e)),
			{ clusters: this.clusters, changed: s }
		);
	}
	cluster({ map: t }) {
		return this.superCluster
			.getClusters([-180, -90, 180, 90], Math.round(t.getZoom()))
			.map((t) => this.transformCluster(t));
	}
	transformCluster({
		geometry: {
			coordinates: [t, e],
		},
		properties: s,
	}) {
		if (s.cluster)
			return new o({
				markers: this.superCluster
					.getLeaves(s.cluster_id, 1 / 0)
					.map((t) => t.properties.marker),
				position: { lat: e, lng: t },
			});
		const a = s.marker;
		return new o({ markers: [a], position: r.getPosition(a) });
	}
}
class v extends p {
	constructor(t) {
		var { maxZoom: r, radius: o = 60, viewportPadding: a = 60 } = t,
			i = s(t, ["maxZoom", "radius", "viewportPadding"]);
		super({ maxZoom: r, viewportPadding: a }),
			(this.superCluster = new e(
				Object.assign({ maxZoom: this.maxZoom, radius: o }, i)
			)),
			(this.state = { zoom: -1, view: [0, 0, 0, 0] });
	}
	calculate(e) {
		const s = {
			zoom: Math.round(e.map.getZoom()),
			view: n(
				e.map.getBounds(),
				e.mapCanvasProjection,
				this.viewportPadding
			),
		};
		let o = !t(this.state, s);
		if (!t(e.markers, this.markers)) {
			(o = !0), (this.markers = [...e.markers]);
			const t = this.markers.map((t) => {
				const e = r.getPosition(t);
				return {
					type: "Feature",
					geometry: {
						type: "Point",
						coordinates: [e.lng(), e.lat()],
					},
					properties: { marker: t },
				};
			});
			this.superCluster.load(t);
		}
		return (
			o && ((this.clusters = this.cluster(e)), (this.state = s)),
			{ clusters: this.clusters, changed: o }
		);
	}
	cluster({ map: t, mapCanvasProjection: e }) {
		const s = {
			zoom: Math.round(t.getZoom()),
			view: n(t.getBounds(), e, this.viewportPadding),
		};
		return this.superCluster
			.getClusters(s.view, s.zoom)
			.map((t) => this.transformCluster(t));
	}
	transformCluster({
		geometry: {
			coordinates: [t, e],
		},
		properties: s,
	}) {
		if (s.cluster)
			return new o({
				markers: this.superCluster
					.getLeaves(s.cluster_id, 1 / 0)
					.map((t) => t.properties.marker),
				position: { lat: e, lng: t },
			});
		const a = s.marker;
		return new o({ markers: [a], position: r.getPosition(a) });
	}
}
class x {
	constructor(t, e) {
		this.markers = { sum: t.length };
		const s = e.map((t) => t.count),
			r = s.reduce((t, e) => t + e, 0);
		this.clusters = {
			count: e.length,
			markers: {
				mean: r / e.length,
				sum: r,
				min: Math.min(...s),
				max: Math.max(...s),
			},
		};
	}
}
class C {
	render({ count: t, position: e }, s, o) {
		const a = `<svg fill="${
				t > Math.max(10, s.clusters.markers.mean)
					? "#ff0000"
					: "#0000ff"
			}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">\n<circle cx="120" cy="120" opacity=".6" r="70" />\n<circle cx="120" cy="120" opacity=".3" r="90" />\n<circle cx="120" cy="120" opacity=".2" r="110" />\n<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${t}</text>\n</svg>`,
			i = `Cluster of ${t} markers`,
			n = Number(google.maps.Marker.MAX_ZINDEX) + t;
		if (r.isAdvancedMarkerAvailable(o)) {
			const t = new DOMParser().parseFromString(
				a,
				"image/svg+xml"
			).documentElement;
			t.setAttribute("transform", "translate(0 25)");
			const s = { map: o, position: e, zIndex: n, title: i, content: t };
			return new google.maps.marker.AdvancedMarkerElement(s);
		}
		const l = {
			position: e,
			zIndex: n,
			title: i,
			icon: {
				url: `data:image/svg+xml;base64,${btoa(a)}`,
				anchor: new google.maps.Point(25, 25),
			},
		};
		return new google.maps.Marker(l);
	}
}
class M {
	constructor() {
		!(function (t, e) {
			for (let s in e.prototype) t.prototype[s] = e.prototype[s];
		})(M, google.maps.OverlayView);
	}
}
var P;
!(function (t) {
	(t.CLUSTERING_BEGIN = "clusteringbegin"),
		(t.CLUSTERING_END = "clusteringend"),
		(t.CLUSTER_CLICK = "click");
})(P || (P = {}));
const w = (t, e, s) => {
	s.fitBounds(e.bounds);
};
class L extends M {
	constructor({
		map: t,
		markers: e = [],
		algorithmOptions: s = {},
		algorithm: r = new f(s),
		renderer: o = new C(),
		onClusterClick: a = w,
	}) {
		super(),
			(this.markers = [...e]),
			(this.clusters = []),
			(this.algorithm = r),
			(this.renderer = o),
			(this.onClusterClick = a),
			t && this.setMap(t);
	}
	addMarker(t, e) {
		this.markers.includes(t) || (this.markers.push(t), e || this.render());
	}
	addMarkers(t, e) {
		t.forEach((t) => {
			this.addMarker(t, !0);
		}),
			e || this.render();
	}
	removeMarker(t, e) {
		const s = this.markers.indexOf(t);
		return (
			-1 !== s &&
			(r.setMap(t, null),
			this.markers.splice(s, 1),
			e || this.render(),
			!0)
		);
	}
	removeMarkers(t, e) {
		let s = !1;
		return (
			t.forEach((t) => {
				s = this.removeMarker(t, !0) || s;
			}),
			s && !e && this.render(),
			s
		);
	}
	clearMarkers(t) {
		(this.markers.length = 0), t || this.render();
	}
	render() {
		const t = this.getMap();
		if (t instanceof google.maps.Map && t.getProjection()) {
			google.maps.event.trigger(this, P.CLUSTERING_BEGIN, this);
			const { clusters: e, changed: s } = this.algorithm.calculate({
				markers: this.markers,
				map: t,
				mapCanvasProjection: this.getProjection(),
			});
			if (s || null == s) {
				const t = new Set();
				for (const s of e) 1 == s.markers.length && t.add(s.markers[0]);
				const s = [];
				for (const e of this.clusters)
					null != e.marker &&
						(1 == e.markers.length
							? t.has(e.marker) || r.setMap(e.marker, null)
							: s.push(e.marker));
				(this.clusters = e),
					this.renderClusters(),
					requestAnimationFrame(() =>
						s.forEach((t) => r.setMap(t, null))
					);
			}
			google.maps.event.trigger(this, P.CLUSTERING_END, this);
		}
	}
	onAdd() {
		(this.idleListener = this.getMap().addListener(
			"idle",
			this.render.bind(this)
		)),
			this.render();
	}
	onRemove() {
		google.maps.event.removeListener(this.idleListener), this.reset();
	}
	reset() {
		this.markers.forEach((t) => r.setMap(t, null)),
			this.clusters.forEach((t) => t.delete()),
			(this.clusters = []);
	}
	renderClusters() {
		const t = new x(this.markers, this.clusters),
			e = this.getMap();
		this.clusters.forEach((s) => {
			1 === s.markers.length
				? (s.marker = s.markers[0])
				: ((s.marker = this.renderer.render(s, t, e)),
				  s.markers.forEach((t) => r.setMap(t, null)),
				  this.onClusterClick &&
						s.marker.addListener("click", (t) => {
							google.maps.event.trigger(this, P.CLUSTER_CLICK, s),
								this.onClusterClick(t, s, e);
						})),
				r.setMap(s.marker, e);
		});
	}
}
export {
	u as AbstractAlgorithm,
	p as AbstractViewportAlgorithm,
	o as Cluster,
	x as ClusterStats,
	C as DefaultRenderer,
	d as GridAlgorithm,
	L as MarkerClusterer,
	P as MarkerClustererEvents,
	r as MarkerUtils,
	k as NoopAlgorithm,
	f as SuperClusterAlgorithm,
	v as SuperClusterViewportAlgorithm,
	w as defaultOnClusterClickHandler,
	l as distanceBetweenPoints,
	i as extendBoundsToPaddedViewport,
	c as extendPixelBounds,
	a as filterMarkersToPaddedViewport,
	n as getPaddedViewport,
	g as noop,
	h as pixelBoundsToLatLngBounds,
};
export default null;



// WEBPACK FOOTER //
// ./project/client/src/vendor/googlemaps/markerclusterer-v2.5.3.esm.js